// React Router v6 compatibility shim for history
// In React Router v6, we don't need a separate history object
// This shim provides a minimal interface for backward compatibility
import { logger } from '@utils/logger';

// Listen for navigation changes
if (typeof window !== 'undefined') {
  const originalPushState = window.history.pushState;
  const originalReplaceState = window.history.replaceState;

  window.history.pushState = function(...args) {
    originalPushState.apply(window.history, args);
    const location = { pathname: window.location.pathname };
    if (location.pathname === '/') {
      logger.debug('Reloading for homepage navigation');
      window.location.pathname = '/';
    }
  };

  window.history.replaceState = function(...args) {
    originalReplaceState.apply(window.history, args);
  };
}

// Minimal history shim for backward compatibility
const history = {
  listen: (callback: (location: { pathname: string }) => void) => {
    // In React Router v6, navigation is handled by the router
    // This is a no-op for compatibility
    return () => {};
  },
  push: (path: string) => {
    window.location.href = path;
  },
  replace: (path: string) => {
    window.location.replace(path);
  },
  goBack: () => {
    window.history.back();
  },
  goForward: () => {
    window.history.forward();
  },
  location: {
    pathname: typeof window !== 'undefined' ? window.location.pathname : '/',
    search: typeof window !== 'undefined' ? window.location.search : '',
    hash: typeof window !== 'undefined' ? window.location.hash : '',
    state: null,
    key: '',
  },
};

export default history;
